module.exports = __webpack_public_path__ + "static/media/play-store.3038620a.svg";